<template>
  <div>
    <ErrorPage v-if="error404occured" />
    <div v-else>
      <div class="branded-provider-nav">
        <div class="container">
          <span class="menu-label d-block d-sm-inline-block pt-2 pt-sm-0 mr-sm-3 mx-0">{{ $t('CC01-03-07') }}</span>
          <span
            v-for="(item, index) in tabList"
            :id="item.id"
            :key="index"
            :active="item.value === activeTab"
            class="nav-link header-label cursor-pointer d-inline-block mx-0 mx-sm-2"
            :class="activeTab === item.value ? 'active theme-tab' : ''"
            @click="switchTab(item.value)"
          >
            {{ $t(item.label) }}
          </span>
        </div>
      </div>
      <div>
        <SkeletonUI v-if="activeTab === '' && loading" type="empty" class="loading-tab" />
        <template v-if="activeTab === 'home'">
          <ProviderInfoHomeClassic v-if="provider_info[0].theme_data && provider_info[0].theme_data.theme_type_code && provider_info[0].theme_data.theme_type_code.toLowerCase() === 'classic'" :providerInfo="provider_info" :themeColor="theme_color" :latestApis="latest_api" class="branded-tab" />
          <ProviderInfoHomeBoxed v-else-if="provider_info[0].theme_data && provider_info[0].theme_data.theme_type_code && provider_info[0].theme_data.theme_type_code.toLowerCase() === 'boxed'" :providerInfo="provider_info" :themeColor="theme_color" :latestApis="latest_api" class="branded-tab" />
          <ProviderInfoHomeModern v-else-if="provider_info[0].theme_data && provider_info[0].theme_data.theme_type_code && provider_info[0].theme_data.theme_type_code.toLowerCase() === 'modern'" :providerInfo="provider_info" :themeColor="theme_color" :latestApis="latest_api" class="branded-tab" />
          <ProviderInfoHomeGallery v-else-if="provider_info[0].theme_data && provider_info[0].theme_data.theme_type_code && provider_info[0].theme_data.theme_type_code.toLowerCase() === 'gallery'" :providerInfo="provider_info" :themeColor="theme_color" :latestApis="latest_api" class="branded-tab" />
          <ProviderInfoHomeStandard v-else :providerInfo="provider_info" :themeColor="theme_color" :latestApis="latest_api" class="branded-tab" />
        </template>
        <ProviderInfoApi v-if="activeTab === 'api'" :providerInfo="provider_info" :themeColor="theme_color" :apiGroups="api_groups" class="branded-tab" />
        <ProviderInfoGuides v-if="activeTab === 'guides'" :providerInfo="provider_info" :themeColor="theme_color" :guides="guides" :lastUpdateDate="last_update_date" :apis="apis" class="branded-tab" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ProviderInfoHomeStandard from './components/home/standard'
import ProviderInfoHomeClassic from './components/home/classic'
import ProviderInfoHomeBoxed from './components/home/boxed'
import ProviderInfoHomeModern from './components/home/modern'
import ProviderInfoHomeGallery from './components/home/gallery'
import ProviderInfoApi from './components/api'
import ProviderInfoGuides from './components/guides'
import SkeletonUI from '@/components/skeleton-ui'
import { getAuthInfo, getProviderInfo, getBeforeLoginAPI, getTopFiveAPI, searchAPI } from '@/api/profile'
import { getReadme } from '@/api/readme'
import ErrorPage from '@/views/error-page/index'
import Axios from 'axios'
const $ = require('jquery')

export default {
  name: 'ProviderInfoBranded',
  components: {
    ProviderInfoHomeStandard,
    ProviderInfoHomeClassic,
    ProviderInfoHomeBoxed,
    ProviderInfoHomeModern,
    ProviderInfoHomeGallery,
    ProviderInfoApi,
    ProviderInfoGuides,
    ErrorPage,
    SkeletonUI
  },
  data() {
    return {
      activeTab: '',
      goingToTab: '',
      provider_short_id: '',
      provider_info: [],
      latest_api: [],
      api_groups: ['All'],
      apis: [],
      guides: '',
      last_update_date: '',
      theme_color: '#57ABF0',
      tabList: [
        { label: 'CC01-03-08', value: 'home', id: 'ga-CC01-03-08', tab_name: 'Meta-M05a-tab' },
        { label: 'CC01-03-09', value: 'api', id: 'ga-CC01-03-09', tab_name: 'Meta-M05b-tab' },
        { label: 'CC01-03-10', value: 'guides', id: 'ga-CC01-03-10', tab_name: 'Meta-M05d-tab' }
      ],
      setCss: false,
      error404occured: false
    }
  },
  computed: {
    loggedIn() {
      return this.$store.getters.login
    },
    ...mapGetters(['userProfile', 'loading', 'site_info'])
  },
  watch: {
    $route(to, from) {
      if (to.params && to.params.tab_name && to.params?.tab_name !== from.params?.tab_name) {
        this.goingToTab = to.params.tab_name
      }
    },
    async goingToTab() {
      if (this.goingToTab !== '') {
        if (this.provider_info[0] && this.provider_info[0]?.provider_type !== 'public') {
          const auth = await getAuthInfo().catch(e => {
            return {}
          })
          if ($.isEmptyObject(auth)) {
            const redirectURL = `${window.location.pathname.substring(0, window.location.pathname.lastIndexOf('/'))}/${this.goingToTab}`
            this.$router.push({
              name: 'login-to-continue',
              params: this.$route.params,
              query: {
                redirect: encodeURIComponent(redirectURL)
              }
            })
          } else {
            this.activeTab = this.goingToTab
          }
        } else {
          this.activeTab = this.goingToTab
        }
      }
    },
    activeTab() {
      if (this.$route.hash !== '' && this.activeTab === 'guides') {
        this.$router.push({
          name: 'provider-info-branded',
          params: {
            ...this.$route.params,
            tab_name: this.activeTab
          },
          hash: this.$route.hash
        })
      } else {
        this.$router.push({
          name: 'provider-info-branded',
          params: {
            ...this.$route.params,
            tab_name: this.activeTab
          }
        })
      }
      // change tab title
      var active = this.tabList.find(item => item.value === this.activeTab)
      document.title = this.$t(active.tab_name, { provider_name: this.provider_info[0].display_name, site_name: this.site_info[this.$i18n.locale].name })
      this.goingToTab = ''
    },
    '$i18n.locale'() {
      var active = this.tabList.find(item => item.value === this.activeTab)
      document.title = this.$t(active.tab_name, { provider_name: this.provider_info[0].display_name, site_name: this.site_info[this.$i18n.locale].name })
    }
  },
  async created() {
    var routeParams = this.$route.params && this.$route.params.provider_name.split('-')
    this.provider_short_id = routeParams[routeParams.length - 1]
    await this.initialise()
  },
  beforeDestroy() {
    if (this.setCss) {
      window.document.styleSheets[0].deleteRule(window.document.styleSheets[0].cssRules.length - 1)
      window.document.styleSheets[0].deleteRule(window.document.styleSheets[0].cssRules.length - 1)
      window.document.styleSheets[0].deleteRule(window.document.styleSheets[0].cssRules.length - 1)
      window.document.styleSheets[0].deleteRule(window.document.styleSheets[0].cssRules.length - 1)
      window.document.styleSheets[0].deleteRule(window.document.styleSheets[0].cssRules.length - 1)
      window.document.styleSheets[0].deleteRule(window.document.styleSheets[0].cssRules.length - 1)
      window.document.styleSheets[0].deleteRule(window.document.styleSheets[0].cssRules.length - 1)
      window.document.styleSheets[0].deleteRule(window.document.styleSheets[0].cssRules.length - 1)
      window.document.styleSheets[0].deleteRule(window.document.styleSheets[0].cssRules.length - 1)
      window.document.styleSheets[0].deleteRule(window.document.styleSheets[0].cssRules.length - 1)
      window.document.styleSheets[0].deleteRule(window.document.styleSheets[0].cssRules.length - 1)
      window.document.styleSheets[0].deleteRule(window.document.styleSheets[0].cssRules.length - 1)
      window.document.styleSheets[0].deleteRule(window.document.styleSheets[0].cssRules.length - 1)
      window.document.styleSheets[0].deleteRule(window.document.styleSheets[0].cssRules.length - 1)
      window.document.styleSheets[0].deleteRule(window.document.styleSheets[0].cssRules.length - 1)
    }
  },
  destroyed() {
    this.$store.dispatch('branded/resetBranded')
  },
  methods: {
    async initialise() {
      this.$store.dispatch('app/setLoading', true)
      await this.getProvider(this.provider_short_id)
      if (this.provider_info && this.provider_info[0]) {
        if (this.provider_info[0].theme_data?.theme_color_dark) {
          this.theme_color = this.provider_info[0].theme_data.theme_color_dark.length === 7 && this.provider_info[0].theme_data.theme_color_dark.charAt(0) === '#'
            ? this.provider_info[0].theme_data.theme_color_dark
            : this.theme_color = '#' + this.provider_info[0].theme_data.theme_color_dark
        } else {
          this.theme_color = '#57ABF0'
        }
        const aRgbHex = this.theme_color.substring(1).match(/.{1,2}/g)
        const aRgb = [
          parseInt(aRgbHex[0], 16),
          parseInt(aRgbHex[1], 16),
          parseInt(aRgbHex[2], 16)
        ]
        var sheet = window.document.styleSheets[0]
        sheet.insertRule(
          `a.section-link, a:not(.hs-mega-menu-invoker, .text-white, .cta-button, .go-to, .slick-arrow, .page-link, .link-text-light, .link-text-dark, .theme-button-outline, .footer-button):hover, a.provider-link, .slick-arrow, .dropdown-item:hover, .nav-link.active, .header-label:hover, div.lang-dropdown-item:hover, .badge-container:hover, .theme-text, .theme-link, .theme-button-container, div.theme-hover-link:hover {
            color: ${this.theme_color} !important;
          }`,
          sheet.cssRules.length
        )
        sheet.insertRule(
          `.theme-tab {
            border-bottom: 2px solid ${this.theme_color}; color: ${this.theme_color};
          }`,
          sheet.cssRules.length
        )
        sheet.insertRule(
          `.theme-readme-link-to-provider-section {
            background-color: ${this.hexToRgba(`${this.theme_color}`)} !important; border-left: 3px solid ${this.theme_color} !important;
          }`,
          sheet.cssRules.length
        )
        sheet.insertRule(
          `.theme-button-modern { color: ${this.theme_color} !important; background-color: #FFFFFF !important; background-color: #FFFFFF !important; }`, sheet.cssRules.length
        )
        sheet.insertRule(
          `.theme-button-modern:hover { box-shadow: 0 4px 11px rgba(255, 255, 255, 0.5) !important; }`, sheet.cssRules.length
        )
        sheet.insertRule(
          `.theme-button-outline-modern { color: #FFFFFF !important; background-color: transparent !important; background-color: #FFFFFF !important; }`, sheet.cssRules.length
        )
        sheet.insertRule(
          `.theme-button-outline-modern:hover { filter: brightness(0.85); }`, sheet.cssRules.length
        )
        sheet.insertRule(
          `.provider-branded-home a:not(.text-white, .slick-arrow, .new-api-card, .theme-button-outline, .theme-button-modern):hover {
            filter: brightness(0.85);
          }`,
          sheet.cssRules.length
        )
        sheet.insertRule(`.page-item .page-link:hover { background-color: ${this.theme_color}15; }`, sheet.cssRules.length)
        sheet.insertRule(
          `.go-to:hover, .go-to:focus:hover, .slick-arrow:hover, .page-link.active, .theme-button { background-color: ${this.theme_color} !important; border-color: ${this.theme_color} !important; color: #fff !important; }`, sheet.cssRules.length
        )
        sheet.insertRule(
          `.theme-boxed-hero-section-box-shadow { box-shadow: 2.5rem 1.8rem 0 0.01rem rgba(${aRgb[0]}, ${aRgb[1]}, ${aRgb[2]}, 0.1) !important; }`, sheet.cssRules.length
        )
        sheet.insertRule(
          `.theme-boxed-quick-link-shadow { box-shadow: 0.7rem 0.7rem rgba(${aRgb[0]}, ${aRgb[1]}, ${aRgb[2]}, 0.1), 0 0 0.4rem rgba(140, 152, 164, 0.3) !important; }`, sheet.cssRules.length
        )
        sheet.insertRule(
          `.theme-boxed-api-carousel-container-shadow { box-shadow: 2rem 0.3rem 0 2rem rgba(${aRgb[0]}, ${aRgb[1]}, ${aRgb[2]}, 0.1) !important; }`, sheet.cssRules.length
        )
        sheet.insertRule(
          `.theme-boxed-api-carousel-container-background { background: rgba(${aRgb[0]}, ${aRgb[1]}, ${aRgb[2]}, 0.1) !important; }`, sheet.cssRules.length
        )
        sheet.insertRule(
          `.theme-boxed-how-it-works-container-background { background: rgba(${aRgb[0]}, ${aRgb[1]}, ${aRgb[2]}) !important; }`, sheet.cssRules.length
        )
        sheet.insertRule(
          `.theme-boxed-hero-cover-image { background: rgba(${aRgb[0]}, ${aRgb[1]}, ${aRgb[2]}) !important; }`, sheet.cssRules.length
        )
        sheet.insertRule(
          `.theme-icon-bg { background-color: rgba(${aRgb[0]}, ${aRgb[1]}, ${aRgb[2]}, 0.1) !important;}`, sheet.cssRules.length
        )
        sheet.insertRule(
          `.theme-circle-container-background {
              border-radius: 50% !important;
              text-align: center !important;
              display: flex;
              justify-content: center;
              align-items: center;
              width: 3rem;
              height: 3rem;
            }`, sheet.cssRules.length
        )
        sheet.insertRule(
          `.theme-boxed-circle-container-background {
              background: rgba(${aRgb[0]}, ${aRgb[1]}, ${aRgb[2]}) !important;
              color: rgb(255, 255, 255) !important;
            }`, sheet.cssRules.length
        )
        sheet.insertRule(
          `.theme-gallery-circle-container-background {
              background: rgb(255, 255, 255) !important;
              color: rgba(${aRgb[0]}, ${aRgb[1]}, ${aRgb[2]}) !important;
              width: 4rem !important;
              height: 4rem !important;
              font-size: 1.5rem !important;
            }`, sheet.cssRules.length
        )
        sheet.insertRule(
          `.theme-button-outline { color: ${this.theme_color} !important; border-color: ${this.theme_color} !important; }`, sheet.cssRules.length
        )
        sheet.insertRule(
          `.theme-button:hover, .theme-button-outline:hover, .theme-button:focus, .theme-button-outline:focus { box-shadow: 0 4px 11px rgba(${aRgb[0]}, ${aRgb[1]}, ${aRgb[2]}, 0.35) !important;}`, sheet.cssRules.length
        )
        sheet.insertRule(
          `.theme-button-outline:hover, .theme-button-outline:focus { background-color: ${this.theme_color} !important; color: #fff !important; }`, sheet.cssRules.length
        )
        sheet.insertRule(
          `.theme-bg { background-color: ${this.theme_color} !important; }`, sheet.cssRules.length
        )
        sheet.insertRule(`.card-frame:hover { border-color: ${this.theme_color} !important; }`, sheet.cssRules.length)
        // Style for Gallery Theme
        if (this.provider_info[0].theme_data?.theme_type_code === 'gallery') {
          sheet.insertRule(`
              .theme-gallery-gradient-background {
                ${this.provider_info[0].theme_data.landing &&
                this.provider_info[0].theme_data.landing.ts_section &&
                this.provider_info[0].theme_data.landing.ts_section.gradient_color ? this.provider_info[0].theme_data.landing.ts_section.gradient_color : 'background: rgb(33,47,76);background: linear-gradient(135deg, rgba(33,47,76,1) 0%, rgba(5,54,105,1) 50%, rgba(77,105,153,1) 100%)'} !important;
              }`, sheet.cssRules.length
          )
          sheet.insertRule(`
              .theme-gallery-button { 
                border-radius: 3rem !important;
                font-size: 0.85rem !important;
                padding: 8px 15px !important;
              }`, sheet.cssRules.length
          )
          sheet.insertRule(`
              .theme-gallery-button-outline {
                background: rgba(255, 255, 255, 0) !important;
                border-color: rgb(255, 255, 255) !important;
                color: rgb(255, 255, 255) !important;
              }`, sheet.cssRules.length
          )
          sheet.insertRule(`
              .theme-gallery-button-outline:hover, .theme-gallery-button-outline:focus  {
                background: rgb(255, 255, 255) !important;
                border-color: rgb(255, 255, 255) !important;
                color: rgba(${aRgb[0]}, ${aRgb[1]}, ${aRgb[2]}) !important;
              }`, sheet.cssRules.length
          )
        }
        this.setCss = true
        this.$store.dispatch('branded/setThemeColour', this.theme_color)
        if (this.provider_info[0].theme_data?.footer_color) {
          if ((this.provider_info[0].theme_data.footer_color.length === 7) && (this.provider_info[0].theme_data.footer_color.charAt(0) === '#')) {
            this.footer_color = this.provider_info[0].theme_data.footer_color
          } else {
            if (this.provider_info[0].theme_data.footer_color.length === 6) {
              this.footer_color = '#' + this.provider_info[0].theme_data.footer_color
            }
          }
          this.$store.dispatch('branded/setFooterColour', this.footer_color)
        }
        this.provider_info[0].theme_data?.header_icon ? this.$store.dispatch('branded/setColourLogo', this.provider_info[0].theme_data.header_icon) : null
        this.provider_info[0].theme_data?.white_logo ? this.$store.dispatch('branded/setFooterLogo', this.provider_info[0].theme_data.white_logo) : null
        this.$store.dispatch('branded/setProviderInfo', {
          display_name: this.provider_info[0].display_name,
          company_business_email: this.provider_info[0].company_business_email,
          company_technical_email: this.provider_info[0].company_technical_email,
          contact_phone_country: this.provider_info[0].contact_phone_country,
          contact_phone_number: this.provider_info[0].contact_phone_number,
          provider_website: this.provider_info[0].provider_website,
          verification_status: this.provider_info[0].verification_status
        })
        if (this.provider_info[0].theme_data?.custom_url && this.provider_info[0].theme_data?.custom_url.length > 0) {
          this.$store.dispatch('branded/setSitemap', this.provider_info[0].theme_data?.custom_url)
        }
      }
      this.$nextTick(() => {
        this.$store.dispatch('app/setLoading', false)
      })
    },
    async getProvider(providerShortId) {
      await getProviderInfo(this.userProfile.id, providerShortId)
        .then(async res => {
          const response = res['data'].map(provider => {
            return {
              ...provider,
              company_business_email: provider.business_support_email,
              company_technical_email: provider.technical_support_email,
              provider_id: provider.id,
              provider_short_id: provider.short_id,
              provider_industry: provider.industry,
              provider_short_description: provider.short_description,
              provider_website: provider.website,
              provider_type: provider.accessibility
            }
          })
          this.provider_info = response
          if (this.provider_info.length === 0) {
            this.error404occured = true
            this.$store.dispatch('app/setLoading', false)
          } else {
            if (this.provider_info[0].theme_data && this.provider_info[0].theme_data.cover_photo_url) {
              this.provider_info[0].theme_data && this.provider_info[0].theme_data.landing && this.provider_info[0].theme_data.landing.hero_section && this.provider_info[0].theme_data.landing.hero_section.cover_photo_url
                ? null
                : this.provider_info[0].theme_data['landing'] = {
                  ...this.provider_info[0].theme_data['landing'],
                  hero_section: {
                    ...(this.provider_info[0].theme_data['landing'] && this.provider_info[0].theme_data['landing']['hero_section'] ? this.provider_info[0].theme_data['landing']['hero_section'] : null),
                    cover_photo_url: this.provider_info[0].cover_photo_url
                  }
                }
            }
            if (this.provider_info[0].theme_data && this.provider_info[0].theme_data.landing_page && this.provider_info[0].theme_data.landing_page.length > 0) {
              var landing_page = []
              this.provider_info[0].theme_data.landing_page.map(section => {
                if (section.section_title) {
                  landing_page.push({
                    title: section.section_title,
                    description: section.section_description,
                    image_url: section.image_url
                  })
                }
              })
              this.provider_info[0].theme_data && this.provider_info[0].theme_data.landing && this.provider_info[0].theme_data.landing.hiw_section && this.provider_info[0].theme_data.landing.hiw_section.items && this.provider_info[0].theme_data.landing.hiw_section.items.length > 0
                ? null
                : this.provider_info[0].theme_data['landing'] = {
                  ...this.provider_info[0].theme_data['landing'],
                  hiw_section: {
                    items: landing_page
                  }
                }
            }
            this.$store.dispatch('branded/setThemeCode', this.provider_info[0].theme_code)
            if (this.provider_info[0].theme_code.toUpperCase() !== 'VIP' && this.provider_info[0].theme_code.toUpperCase() !== 'VVIP') {
              this.$router.push({
                name: 'provider-info',
                params: {
                  ...this.$route.params,
                  tab_name: 'home'
                }
              })
            }
            // for Home page
            if (this.loggedIn && this.userProfile.id !== '') {
              await this.getTopFiveAPIInfo()
            } else {
              await this.getBeforeLoginAPIInfo()
            }
            // for API Collection page
            if (this.provider_info[0].api_groups) {
              this.api_groups = this.api_groups.concat(this.provider_info[0].api_groups.sort())
            }
            // for Guides page
            if (this.provider_info[0].guides && this.provider_info[0].guides.split('.').pop() === 'md') {
              this.last_update_date = this.provider_info[0] && this.provider_info[0]?.last_edit
              await this.getReadme()
            }
            await this.getAPIListInfo()
            this.initialiseTab()
          }
        })
        .catch(error => {
          console.log('getProviderInfo error', error)
          this.error404occured = true
          this.$store.dispatch('app/setLoading', false)
        })
    },
    async getTopFiveAPIInfo() {
      await getTopFiveAPI(this.userProfile.id, this.provider_short_id)
        .then(res => {
          const response = res['data'].map(api => {
            return {
              ...api,
              api_id: api.id,
              api_short_id: api.short_id,
              api_name: api.name,
              api_type: api.accessibility,
              api_description: api.short_description,
              api_category: api.category,
              api_no_of_calls: api.request_count,
              api_errors_percentage: api.success_rate,
              api_latency: api.average_latency,
              api_provider_group: api.groups,
              display_name: api.provider_display_name
            }
          })
          this.latest_api = response
        })
        .catch(error => {
          console.log('getTopFiveAPI error', error)
        })
    },
    async getBeforeLoginAPIInfo() {
      await getBeforeLoginAPI(this.provider_short_id)
        .then(res => {
          const response = res['data'].map(api => {
            return {
              ...api,
              api_id: api.id,
              api_short_id: api.short_id,
              api_name: api.name,
              api_type: api.accessibility,
              api_description: api.short_description,
              api_category: api.category,
              api_no_of_calls: api.request_count,
              api_errors_percentage: api.success_rate,
              api_latency: api.average_latency,
              api_provider_group: api.groups,
              display_name: api.provider_display_name
            }
          })
          this.latest_api = response
        })
        .catch(error => {
          console.log('getTopFiveAPI error', error)
        })
    },
    async getReadme() {
      await getReadme(this.provider_info[0].guides)
        .then(res => {
          this.guides = res['data']
        })
        .catch(error => {
          console.log('getProviderInfo error', error)
        })
    },
    async getAPIListInfo() {
      const axiosSource = Axios.CancelToken.source()
      var filter = { providerShortId: this.provider_short_id }
      await searchAPI(axiosSource.token, this.userProfile.id, 100, 0, filter)
        .then(res => {
          const response = res['data'].map(api => {
            return {
              ...api,
              api_id: api.id,
              api_short_id: api.short_id,
              api_name: api.name,
              api_type: api.accessibility,
              api_description: api.short_description,
              api_category: api.category,
              api_no_of_calls: api.request_count,
              api_errors_percentage: api.success_rate,
              api_latency: api.average_latency,
              api_provider_group: api.groups,
              display_name: api.provider_display_name
            }
          })
          this.apis = response
        })
        .catch(error => {
          console.log('getAPIList error', error)
        })
    },
    initialiseTab() {
      var active = this.tabList.find(item => item.value === this.$route.params.tab_name)
      if (this.$route.params.tab_name && active) {
        this.activeTab = this.$route.params.tab_name
        document.title = this.$t(active.tab_name, { provider_name: this.provider_info[0].display_name, site_name: this.site_info[this.$i18n.locale].name })
      } else {
        this.activeTab = 'home'
      }
    },
    switchTab(tab) {
      this.goingToTab = tab
    },
    hexToRgba(hex) {
      if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        var c = hex.substring(1).split('')
        if (c.length === 3) {
          c = [c[0], c[0], c[1], c[1], c[2], c[2]]
        }
        c = '0x' + c.join('')
        return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',0.1)'
      } else return '#fff'
    }
  }
}
</script>

<style lang="scss" scoped>
.menu-label, .header-label {
  font-size: 14px;
}
.menu-label {
  color: #999;
}
.branded-provider-nav {
  background-color: #f7f7f7;
  .container {
    min-height: 40px;
  }
}
.branded-tab {
  min-height: calc(100vh - 484px);
}
</style>
